import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { SearchResults } from "../../../types/search/search-results.interface";
import { IProductDetail } from "../../../types/product/iproduct-detail.interface";

export enum ProductsActions {
  Search = "Products/Search",
  SearchSuccess = "Products/SearchSuccess",
  SearchFailure = "Products/SearchFailure",
}

export const search = (searchTerm: string) => action(ProductsActions.Search, searchTerm);
export const searchSuccess = (results: SearchResults<IProductDetail>) =>
  action(ProductsActions.SearchSuccess, results);
export const searchFailure = (error: IError) => action(ProductsActions.SearchFailure, error);

const actionCreators = {
  search,
  searchSuccess,
  searchFailure,
};

export type ProductsActionType = ActionType<typeof actionCreators>;
